<template>
    <div
        class="section-selector"
        :class="{ '-disabled': section.disabled || disabled }"
    >
        <div class="option">
            {{ options.false }}
        </div>
        <label class="switch">
            <input
                type="checkbox"
                v-model="checked"
                :value="value"
                @change="onChange"
            />
            <span class="slider round"></span>
        </label>
        <div class="option">
            {{ options.true }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'SectionSwitch',
    props: {
        value: Boolean,
        options: Object,
        section: Object,
        disabled: Boolean
    },
    data() {
        return {
            checked: false
        }
    },
    methods: {
        onChange($event) {
            let value = $event.target.checked
            this.$emit('input', value)
        }
    },
    watch: {
        value() {
            this.checked = this.value
        }
    },
    mounted() {
        this.checked = this.value
    }
}
</script>
<style lang="scss" scoped>
.section-selector {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    font-family: $input-family;
    padding: 0.4rem 1rem;
}
.switch {
    position: relative;
    display: inline-block;
    width: 3rem;
    height: 0.8rem;
    margin: 0 1rem;
    margin-bottom: -0.2rem;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(197, 197, 197);
    -webkit-transition: 0.4s;
    transition: 0.4s;
}
.slider:before {
    position: absolute;
    content: '';
    height: 1.2rem;
    width: 1.2rem;
    left: -4px;
    bottom: -0.2rem;
    background-color: rgb(240, 240, 240);
    -webkit-transition: 0.4s;
    transition: 0.4s ease;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
}

input:checked + .slider:before {
    transform: translateX(2.2rem);
    background-color: $accent-apple;
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
